#import "../fragments/product-fragment.graphql"

mutation DeleteProduct($input: ProductDeleteInput!) {
    productDelete(input: $input) {
        product {
            ...ProductFragment
        }
    }
}
